import { Injectable } from '@angular/core';
import { IResourceMethodPromise, Resource, ResourceAction, ResourceHandler, ResourceParams, ResourceRequestMethod } from '@ngx-resource/core';
import { IMongooseResult } from './api.module';

@ResourceParams({
  pathPrefix: '/api/order'
})
@Injectable()
export class OrderResource extends Resource {

  constructor(handler: ResourceHandler) {
    super(handler);
  }


  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: ''
  })
  query: IResourceMethodPromise<any, IMongooseResult<any>>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}'
  })
  getOne: IResourceMethodPromise<any, any>;

  @ResourceAction({
    method: ResourceRequestMethod.Get,
    path: '/{!nmbr}/product'
  })
  getProducts: IResourceMethodPromise<any, IMongooseResult<any>>;


}
